import { isEqual } from 'lodash';

const normalisedEmptyValues = (obj: unknown): unknown => {
  if (obj === null || obj === undefined || obj === '') {
    return null;
  }

  if (Array.isArray(obj)) {
    return obj.map(normalisedEmptyValues);
  }

  if (typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        normalisedEmptyValues(value),
      ]),
    );
  }

  return obj;
};

export const isEqualEmptyNormalised = (a: unknown, b: unknown): boolean => {
  return isEqual(normalisedEmptyValues(a), normalisedEmptyValues(b));
};
